<div class="p-4 bg-light-subtle">
    <h3 class="p-4">
        Session timed out. Please extend your session or Logout.
    </h3>
    <div class="flex p-4 justify-content-end gap-3" style="display: flex;">
        <button class="black-button" (click)="logout()">LOGOUT</button>
        <button class="vpacs-btn-table" (click)="getSilentToken()">EXTEND SESSION</button>
    </div>
</div>
